export default __webpack_public_path__ + "static/media/strategy-tip-for-your-business.4ff51195.png";